import { TranslateService } from "@ngx-translate/core";

export function localizeDatePicker(translate: TranslateService) {
    const locale = {
      applyLabel: translate.instant('DATE-PICKER.OK-LABEL'),
      format: translate.instant('DATE-PICKER.FORMAT'),
      clearLabel: translate.instant('DATE-PICKER.CLEAR-LABEL'),
      daysOfWeek: translate.instant('DATE-PICKER.DAY-OF-WEEK'),
      firstDay: translate.instant('DATE-PICKER.FIRST-DAY'),
      monthNames: translate.instant('DATE-PICKER.MONTH-NAMES')
    };
    return locale;
}

export function getDefaultCalendarConfig() {
    return {
        applyLabel: 'ok',
        format: 'DD/MM/YYYY',
        clearLabel: 'Clear',
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        firstDay: 7,
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      };
}


